import { useState, useEffect } from 'react'
import { exchanges as mockData } from '../data/mockData'
import { Exchange } from '../types'

export function useExchangeData() {
  const [data, setData] = useState<Exchange[]>(mockData)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [lastUpdated, setLastUpdated] = useState<Date>(new Date())

  // Note: CMC Exchange API requires higher tier plan
  // For now, using mock data with periodic updates
  // You can upgrade to fetch real exchange data later

  const fetchData = async () => {
    try {
      setLoading(true)
      setError(null)

      // Placeholder for future exchange API integration
      // const cmcData = await cmcService.getExchangeMap();

      setLastUpdated(new Date())
    } catch (err) {
      console.error('Error fetching exchange data:', err)
      setError(err instanceof Error ? err.message : 'Failed to fetch data')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    // Auto-refresh every 5 minutes
    const interval = setInterval(fetchData, 300000)

    return () => clearInterval(interval)
  }, [])

  return { data, loading, error, lastUpdated, refresh: fetchData }
}
